import React, { createContext, useContext, useState, useEffect } from 'react';
import AuthService from '../services/auth.service';
const AuthContext = createContext({
    isAuthenticated: false,
    isAuthLoading: true,
});
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    useEffect(() => {
        const checkAuth = () => {
            const authStatus = AuthService.isAuthenticated;
            setIsAuthenticated(authStatus);
            setIsAuthLoading(false);
        };
        // Check authentication status
        checkAuth();
        // Set up a periodic check for authentication changes
        const interval = setInterval(checkAuth, 1000);
        return () => clearInterval(interval);
    }, []);
    return <AuthContext.Provider value={{ isAuthenticated, isAuthLoading }}>{children}</AuthContext.Provider>;
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
